module.exports = {
  dev: require("./dev"),
  prod: require("./prod"),
}